<template>
	<div>
		<toolbar>
			<router-link to="/contacts" class="btn btn-link">
				<i class="fa fa-caret-left fa-2x"></i>
				<h2>Contacts</h2>
			</router-link>

			<slot name="left"></slot>

			<div class="controls">
				<slot></slot>
				<nav-tabs :tabs="tabs" :mobile-breakpoint="1024"></nav-tabs>
			</div>
		</toolbar>

		<div class="d-flex flex-row flex-wrap justify-content-between" v-if="$route.params.id != 'new' && heading">
			<h2>
				{{heading}}
				<br>
				<small v-if="subHeading" class="text-muted">{{subHeading}}</small>
				<small v-else-if="$store.contact && 'name' in $store.contact" class="text-muted">{{$store.contact.name}}</small>
			</h2>
			<slot name="main"></slot>
		</div>

	</div>
</template>
<script type="text/javascript">
import NavTabs from "@/layout_fragments/NavTabs"
import Toolbar from "@/layout_fragments/Toolbar"

export default {
	name: "ContactToolbar",
	components: {
		NavTabs,
		Toolbar
	},
	props: ["heading","subHeading"],
	computed: {
		tabs() {
			if (this.$route.params.id == 'new')
				return []

			let numFiles = ""
			if (this.$store.contact.ContactFile && this.$store.contact.ContactFile.length > 0)
				numFiles = " ("+this.$store.contact.ContactFile.length+")"

			let tabs = [
				{
					label: "Summary",
					path: "/contact/"+this.$route.params.id+"/summary",
					icon: "fa-address-card"
				},
				{
					label: "Details",
					path: "/contact/"+this.$route.params.id+"/details",
					icon: "fa-user"
				},
				{
					label: "Locations",
					path: "/contact/"+this.$route.params.id+"/locations",
					icon: "fa-map-marker"
				},
				{
					label: "Assets",
					path: "/contact/"+this.$route.params.id+"/assets",
					icon: "fa-tractor"
				},
				{
					label: "Active Jobs",
					path: "/contact/"+this.$route.params.id+"/jobs",
					icon: "fa-cubes"
				},
				{

					label: "Files"+numFiles,
					path: "/contact/"+this.$route.params.id+"/files",
					icon: "fa-file-image"
				},
				{
					label: "Service Contracts",
					path: "/contact/"+this.$route.params.id+"/service-contracts",
					icon: "fa-gavel",
					modulePermRequired: ["Contracts"]
				}
			]

			if (window.innerWidth <= 1200) {
				tabs.push({
					label: "Sub-Contacts",
					path: "/contact/"+this.$route.params.id+"/sub-contacts",
					icon: "fa-user"
				})
			}

			if (this.$store.contact && "id" in this.$store.contact && this.$store.contact.is_customer == 1) {
				tabs.push({
					label: "Invoice Settings",
					path: "/contact/"+this.$route.params.id+"/settings",
					icon: "fa-cog",
					modulePermRequired: ["Contacts"]
				})
			}

			if (this.$store.contact && "is_supplier" in this.$store.contact && this.$store.contact.is_supplier == 1) {
				tabs.splice(2,0,{
					label: "Purchases",
					path: "/contact/"+this.$route.params.id+"/purchases/purchase-orders",
					icon: "fa-receipt"
				})
			}

			return tabs
		}
	}
}
</script>